export default __webpack_public_path__ + "static/media/preview-local-account.d975089a.svg";